import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, CodeBlock, BlockType, ValidationMessageType, ValidationMessage, SettingState,
} from '@appblocks/codegeneration/types';

export default class Socket extends BaseFeature {
    constructor() {
        super();
        this.name = 'Socket';
        this.id = 'socket';
        this.requirements = [['zephyr', 'tios']];
        this.icon = 'FaNetworkWired';
        const settings = [
            {
                id: 'SOCKETS',
                name: 'Sockets',
                settingType: SettingType.ARRAY,
                required: true,
                refId: 'socket_connection',
                default: new Array<BaseFeature>(0),
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getEnabled(): boolean {
        const SOCKETS = this.getSettingValue('SOCKETS');
        return SOCKETS.length > 0;
    }

    getDependencies() {
        const dependencies = [
            'sock',
        ];
        return dependencies;
    }

    getCodeBlocks() {
        let blocks: Array<CodeBlock> = [];

        const sockets = this.getSettingValue('SOCKETS');

        for (let i = 0; i < sockets.length; i += 1) {
            blocks = blocks.concat(sockets[i].getCodeBlocks());
        }

        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/lib_sock';
    }
}
